<div class="about-page">
  <!-- Page Hero -->
  <section class="page-hero">
    <h1>Joaquin <span class="highlight">'Highnet'</span> Telleria</h1>
    <p class="role">
      Full-stack & Web3 Developer · UI/UX Designer · Game Developer
    </p>
    <div class="badges">
      <span class="pill">
        <span class="dot dot-yellow"></span>
        Independent
      </span>
      <span class="pill">Vienna, Austria</span>
      <a
        href="https://highnetcv.xyz/"
        target="_blank"
        rel="noopener"
        class="pill pill-link"
        >highnetcv.xyz</a
      >
      <a
        href="https://www.linkedin.com/in/joaquin-telleria-57957aa5"
        target="_blank"
        rel="noopener"
        class="pill pill-link"
        >LinkedIn</a
      >
      <a href="mailto:joaquintelleria&#64;gmail.com" class="pill pill-link"
        >Email</a
      >
      <a href="https://wa.me/+436764204412" class="pill pill-link">WhatsApp</a>
    </div>
  </section>

  <!-- About -->
  <section class="section">
    <span class="section-label">About</span>
    <p class="body-text">
      I'm a full-stack developer with a background in Human-Centered Computing,
      which means I care just as much about how something feels as how it works.
      I've shipped DeFi apps on Ethereum, civic platforms serving hundreds of
      thousands of Viennese residents, a slot engine with cryptographic fairness
      guarantees, and indie games on Steam.
    </p>
  </section>

  <div class="divider"></div>

  <!-- Tech Stack -->
  <section class="section">
    <span class="section-label">Tech Stack</span>
    <div class="skills-grid">
      <div class="skill-group">
        <h3>Core Development</h3>
        <div class="tag-list">
          <span class="tag">JavaScript</span>
          <span class="tag">TypeScript</span>
          <span class="tag">HTML5</span>
          <span class="tag">CSS3/SCSS</span>
        </div>
      </div>
      <div class="skill-group">
        <h3>Front-End Frameworks & Libraries</h3>
        <div class="tag-list">
          <span class="tag">React</span>
          <span class="tag">Next.js</span>
          <span class="tag">Nuxt 3</span>
          <span class="tag">Angular</span>
          <span class="tag">Vite</span>
          <span class="tag">TailwindCSS</span>
          <span class="tag">Shadcn/UI</span>
          <span class="tag">React Three Fiber</span>
          <span class="tag">Framer Motion</span>
          <span class="tag">TresJS</span>
        </div>
      </div>
      <div class="skill-group">
        <h3>State Management</h3>
        <div class="tag-list">
          <span class="tag">Zustand</span>
          <span class="tag">Pinia</span>
          <span class="tag">Tanstack Query</span>
          <span class="tag">Redux</span>
          <span class="tag">XState</span>
        </div>
      </div>
      <div class="skill-group">
        <h3>API & Data Fetching</h3>
        <div class="tag-list">
          <span class="tag">Axios</span>
          <span class="tag">GraphQL</span>
          <span class="tag">GraphQL Yoga</span>
          <span class="tag">REST APIs</span>
          <span class="tag">WebSockets</span>
        </div>
      </div>
      <div class="skill-group">
        <h3>Web3 & Blockchain</h3>
        <div class="tag-list">
          <span class="tag">Viem</span>
          <span class="tag">Wagmi</span>
          <span class="tag">Ethers.js</span>
          <span class="tag">Smart Contract Interactions</span>
          <span class="tag">NFT Development & Deployment (Ethereum)</span>
        </div>
      </div>
      <div class="skill-group">
        <h3>Back-End & Databases</h3>
        <div class="tag-list">
          <span class="tag">Node.js</span>
          <span class="tag">Express</span>
          <span class="tag">Firebase</span>
          <span class="tag">Supabase</span>
          <span class="tag">MongoDB</span>
          <span class="tag">SQL</span>
          <span class="tag">PostgreSQL</span>
          <span class="tag">Drizzle ORM</span>
          <span class="tag">Redis</span>
          <span class="tag">Convex</span>
          <span class="tag">Clerk</span>
        </div>
      </div>
      <div class="skill-group">
        <h3>Auth & Security</h3>
        <div class="tag-list">
          <span class="tag">Argon2id</span>
          <span class="tag">HTTP-only Cookies</span>
          <span class="tag">Session Management</span>
        </div>
      </div>
      <div class="skill-group">
        <h3>Testing</h3>
        <div class="tag-list">
          <span class="tag">Jest</span>
          <span class="tag">Vitest</span>
        </div>
      </div>
      <div class="skill-group">
        <h3>CI/CD & DevOps</h3>
        <div class="tag-list">
          <span class="tag">GitHub Actions</span>
          <span class="tag">Jenkins</span>
          <span class="tag">Docker</span>
          <span class="tag">Turborepo</span>
        </div>
      </div>
      <div class="skill-group">
        <h3>Design Tools</h3>
        <div class="tag-list">
          <span class="tag">Figma</span>
          <span class="tag">Canva</span>
        </div>
      </div>
      <div class="skill-group">
        <h3>Game Development</h3>
        <div class="tag-list">
          <span class="tag">Unity</span>
          <span class="tag">C#</span>
          <span class="tag">Unreal Engine</span>
          <span class="tag">C++</span>
          <span class="tag">OpenGL</span>
          <span class="tag">GLSL</span>
          <span class="tag">Shader Programming</span>
        </div>
      </div>
      <div class="skill-group">
        <h3>Version Control & Deployment</h3>
        <div class="tag-list">
          <span class="tag">Git</span>
          <span class="tag">GitHub</span>
          <span class="tag">Bitbucket</span>
          <span class="tag">TortoiseSVN</span>
          <span class="tag">Vercel</span>
          <span class="tag">Netlify</span>
          <span class="tag">Fly.io</span>
        </div>
      </div>
      <div class="skill-group">
        <h3>Languages</h3>
        <div class="tag-list">
          <span class="tag">English (Fluent)</span>
          <span class="tag">German (Fluent)</span>
          <span class="tag">Spanish (Native)</span>
        </div>
      </div>
    </div>
  </section>

  <div class="divider"></div>

  <!-- Experience -->
  <section class="section">
    <span class="section-label">Experience</span>
    <div class="timeline">
      <div class="timeline-item">
        <div class="timeline-date">Mar 2025 – Apr 2026</div>
        <div class="timeline-content">
          <h3>Frontend Developer</h3>
          <p class="company">WienHolding Digital Services</p>
          <p class="desc">
            Contributing to front-end development projects, including the
            Vorteilsclub Wien platform.
          </p>
        </div>
      </div>
      <div class="timeline-item">
        <div class="timeline-date">Aug 2023 – Jan 2025</div>
        <div class="timeline-content">
          <h3>Web3 Frontend Developer</h3>
          <p class="company">Lindy Labs — Sandclock · Remote</p>
          <p class="desc">
            Contributed to the development and launch of two versions of a DeFi
            application. Developed scalable front-end components and integrated
            blockchain interactions.
          </p>
          <div class="tag-list compact">
            <span class="tag">React</span>
            <span class="tag">TypeScript</span>
            <span class="tag">Next.js</span>
            <span class="tag">Web3</span>
            <span class="tag">Supabase</span>
          </div>
        </div>
      </div>
      <div class="timeline-item">
        <div class="timeline-date">Jan 2023 – Jul 2023</div>
        <div class="timeline-content">
          <h3>Front-end Engineer Intern</h3>
          <p class="company">Wetouch · Vienna</p>
          <p class="desc">
            Developed web applications for public tablet displays. Built an
            interactive touchscreen display for Voestalpine lobbies.
          </p>
          <div class="tag-list compact">
            <span class="tag">React</span>
            <span class="tag">CSS</span>
            <span class="tag">Figma</span>
            <span class="tag">Node.js</span>
            <span class="tag">Docker</span>
          </div>
        </div>
      </div>
      <div class="timeline-item">
        <div class="timeline-date">Jun 2020 – Jan 2023</div>
        <div class="timeline-content">
          <h3>Indie Game Developer</h3>
          <p class="company">Manujoaco Games</p>
          <p class="desc">
            Developed and published "Retro Karting 22" and "Idle Chess Story" on
            Steam.
          </p>
        </div>
      </div>
      <div class="timeline-item">
        <div class="timeline-date">Jul 2022</div>
        <div class="timeline-content">
          <h3>Software Developer (Game Dev II)</h3>
          <p class="company">IGT · Graz</p>
          <p class="desc">
            Worked on the Ocean Treasure Magic Bubble casino game. Implemented
            engaging UIs with a focus on game mechanics.
          </p>
          <div class="tag-list compact">
            <span class="tag">Unity</span>
            <span class="tag">C#</span>
            <span class="tag">GLSL</span>
            <span class="tag">Jenkins</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="divider"></div>

  <!-- Education -->
  <section class="section">
    <span class="section-label">Education</span>
    <div class="timeline">
      <div class="timeline-item">
        <div class="timeline-date">2017 – 2020</div>
        <div class="timeline-content">
          <h3>Technical University of Vienna</h3>
          <p class="company">Human-Centered Computing</p>
        </div>
      </div>
      <div class="timeline-item">
        <div class="timeline-date">2015 – 2016</div>
        <div class="timeline-content">
          <h3>University of Vienna</h3>
          <p class="company">Scientific Computing</p>
        </div>
      </div>
      <div class="timeline-item">
        <div class="timeline-date">2015</div>
        <div class="timeline-content">
          <h3>VHS Polycollege Johannagasse</h3>
          <p class="company">Java Programming</p>
        </div>
      </div>
      <div class="timeline-item">
        <div class="timeline-date">2005 – 2013</div>
        <div class="timeline-content">
          <h3>Vienna International School</h3>
          <p class="company">IB Diploma & Austrian Matura</p>
        </div>
      </div>
    </div>
  </section>

  <div class="divider"></div>

  <!-- CV Download -->
  <section class="section cv-download">
    <button class="btn-download" (click)="downloadCV()">
      Download Full CV
    </button>
    <p class="cv-note">PDF format</p>
  </section>

  <!-- JSON-LD Structured Data -->
  <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "Person",
      "name": "Joaquin Telleria",
      "alternateName": "Highnet",
      "url": "https://highnetcv.xyz/",
      "jobTitle": "Full-Stack Developer",
      "worksFor": [
        {
          "@type": "Organization",
          "name": "WienHolding Digital Services"
        }
      ],
      "alumniOf": [
        {
          "@type": "EducationalOrganization",
          "name": "Technical University of Vienna"
        }
      ],
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Vienna",
        "addressCountry": "AT"
      },
      "knowsLanguage": ["English", "German", "Spanish"],
      "sameAs": [
        "https://github.com/highnet",
        "https://www.linkedin.com/in/joaquin-telleria-57957aa5"
      ]
    }
  </script>
</div>
